<template>
  <div>
    <!-- Grid Section -->
    <div class="container-fluid">
      <div class="row g-3">
      <!-- Individual Buttons -->
        
      <div
        v-for="(item, index) in buttons"
        :key="index"
        :class="[
          'col-6',
          'col-sm-4',
          'col-md-3',
          'no-padding',
          { 'slide-up': isMounted },
        ]"
      >
        <div
          class="w-100 text-center action-wrapper hover"
          @click="navigate(item.routTo)"
        >
          <img :src="item.imgPath" alt="Logo" class="w-100" />
        </div>
      </div>
    </div>
    </div>
    
    <div class="text-center lower-panner">
      <img src="@/assets/lowerPanner.png" alt="lower-panner" class="w-100" />
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation :prevRoute="'/'" :nextRoute="'/pregHome'" /> -->
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
// import FooterNavigation from "@/components/FooterNavigation.vue";

const isMounted = ref(false);

const router = useRouter();

const buttons = [
  { imgPath: require("@/assets/page3/Asset1.png"), routTo: "/pregHome" },
  {
    imgPath: require("@/assets/page3/Asset2.png"),
    routTo: "/adolescentsPage",
  },
  {
    imgPath: require("@/assets/page3/Asset3.png"),
    routTo: "/oldPeoplePage",
  },
  {
    imgPath: require("@/assets/page3/Asset4.png"),
    routTo: "/ImmunocompromisedPage",
  },
  {
    imgPath: require("@/assets/page3/Asset5.png"),
    routTo: "KidneyDiseases",
  },
  {
    imgPath: require("@/assets/page3/Asset6.png"),
    routTo: "HIV",
  },
  {
    imgPath: require("@/assets/page3/Asset7.png"),
    routTo: "HeartDisease",
  },
  {
    imgPath: require("@/assets/page3/Asset8.png"),
    routTo: "Diabetes",
  },
  {
    imgPath: require("@/assets/page3/Asset9.png"),
    routTo: "LungDisease",
  },
  {
    imgPath: require("@/assets/page3/Asset10.png"),
    routTo: "ChronicLiver",
  },
  {
    imgPath: require("@/assets/page3/Asset11.png"),
    routTo: "programPage",
  },
  {
    imgPath: require("@/assets/page3/Asset12.png"),
    routTo: "TravelingPage",
  },
];

// const goBack = () => {
//   router.push("/");
// };

// const goForward = () => {
//   alert("Next page not implemented!");
// };
// Navigation function
const navigate = (route) => {
  if (route) {
    router.push(route);
  }
};
onMounted(() => {
  isMounted.value = true;
});
</script>

<style scoped>
/* Slide-Up Animation */
.slide-up {
  animation: myAnim 4s ease 0s 1 normal forwards; /* Slowed down to 4s */
}

/* Define the Slide-Up Animation */
@keyframes myAnim {
  0% {
    transform: scale(0.5); /* Starts smaller */
  }

  100% {
    transform: scale(1); /* Ends at normal size */
  }
}

.slide-up {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: none;
  border-radius: 10px;
  background-color: #f0f0f0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s;
  cursor: pointer;
}

.slide-up:hover {
  transform: scale(1.05) rotate(5deg); /* Apply both effects */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
}

.nav-buttons {
  margin-top: 20px;
}

.nav-buttons button {
  margin: 0 10px;
  padding: 10px 20px;
  border: none;
  background-color: #d8dbdd;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}

.nav-buttons button:hover {
  background-color: #0056b3;
}
.action-wrapper:hover {
  transform: scale(0.9); /* Shrinks the element */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition */
}

.no-padding {
  padding: 0 !important;
  margin: auto;
  text-align: center;
}
.footer-wrapper {
  background-color: #2c4fa1;
}
.footer-wrapper button {
  color: #f0f0f0;
}
.lower-panner {
  margin-bottom: 7rem;
}
</style>
